import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be6f0572"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg" }
const _hoisted_2 = { class: "container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_typography_title = _resolveComponent("a-typography-title")!
  const _component_a_typography_paragraph = _resolveComponent("a-typography-paragraph")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_SwiperSlide = _resolveComponent("SwiperSlide")!
  const _component_ProductBanner = _resolveComponent("ProductBanner")!
  const _component_Swiper = _resolveComponent("Swiper")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["banner", $data.expand.active])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.expand.index, (item) => {
        return (_openBlock(), _createElementBlock("i", {
          class: _normalizeClass(`b_${item}`)
        }, null, 2 /* CLASS */))
      }), 256 /* UNKEYED_FRAGMENT */))
    ]),
    _createVNode(_component_Swiper, {
      effect: "coverflow",
      speed: 600,
      coverflowEffect: {stretch:-300,slideShadows:false},
      autoplay: {disableOnInteraction:false,delay:6000},
      pagination: {clickable:true},
      onSlideChange: $options.switchSwiper
    }, {
      default: _withCtx(() => [
        _createVNode(_component_SwiperSlide, { class: "item i_store" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_a_typography_title, { level: 1 }, {
                default: _withCtx(() => [
                  _createTextVNode(" 星汉未来致力于打造基于下一代Serverless技术的AI应用平台 ")
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_typography_title, { level: 2 }, {
                default: _withCtx(() => [
                  _createTextVNode(" 旨在迅速让AI成为企业的新质生产力引擎 ")
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_typography_paragraph, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString('星汉未来作为一家AI应用平台厂商，提供AI应用管理、AI算力管理等全方位AI平台服务，以及AI数字人、AI绘画等AI应用服务。' +
              '凭借丰富的专利技术和不懈的产品创新，星汉未来致力于推动AI应用的落地和普及，让AI技术成为企业的增长新动力。'))
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_a_space, {
                size: _ctx.$Store.Public().isGridMatch('>=',_ctx.$Enum.GridEnum.XL)?'large':'small'
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    class: "button_n_1",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => ($options.clickToStore()))
                  }, " SaaS服务 "),
                  _createElementVNode("a", {
                    class: "button_n_1",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => ($options.clickToWhiteBook()))
                  }, " 免费部署 "),
                  _createCommentVNode("<a class=\"button_n_3\""),
                  _createCommentVNode("   @click=\"$Store.Page().openModal('modalDownloadIFP')\">"),
                  _createCommentVNode("  私有化部署"),
                  _createCommentVNode("</a>"),
                  _createCommentVNode("<a class=\"button_n_3\""),
                  _createCommentVNode("  @click=\"$Store.Page().openModal('modalFormCollection', 'deployment')\">"),
                  _createCommentVNode("  预约私有化部署"),
                  _createCommentVNode("</a>"),
                  _createElementVNode("a", {
                    class: "button_n_1",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$router.push(_ctx.$Enum.RouterEnum.License)))
                  }, " 获取License ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["size"])
            ])
          ]),
          _: 1 /* STABLE */
        }),
        _createVNode(_component_SwiperSlide, { class: "item i_store" }, {
          default: _withCtx(() => [
            _createVNode(_component_ProductBanner, {
              isHome: true,
              onClick: _cache[3] || (_cache[3] = ()=>_ctx.$router.push(_ctx.$Enum.RouterEnum.ProductAidigitalHuman))
            })
          ]),
          _: 1 /* STABLE */
        })
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["onSlideChange"])
  ], 2 /* CLASS */))
}